import { nextPage, previousPage, setSessionQuizAnswer, submitQuiz } from "actions/sessionAction";
import { connect } from 'react-redux';
import SessionQuiz from "views/session/SessionQuiz";

import { get } from "lodash";
import { isPreviewSearch } from "common/preview";

const makeNoopIfPreview = (dispatch, isPreview, actionCreator) => (...args) =>
  isPreview ? Promise.resolve() : dispatch(actionCreator(...args));

const mapStateToProps = ({ session: {
  currentQuiz,
  currentPage,
  stepId,
  currentStepQuizAnswers,
  quizError,
  currentSession
} }, ownProps) => ({
  quiz: currentQuiz,
  session: currentSession,
  stepId,
  currentStepQuizAnswers,
  currentPage,
  quizError,
  isPreview: isPreviewSearch(get(ownProps, "location.search", "")),
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const isPreview = isPreviewSearch(get(ownProps, "location.search", ""));
  return {
    nextPage: (...args) => dispatch(nextPage(...args)),
    previousPage: (...args) => dispatch(previousPage(...args)),
    setSessionQuizAnswer: (...args) => dispatch(setSessionQuizAnswer(...args)),
    submitQuiz: makeNoopIfPreview(dispatch, isPreview, submitQuiz),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionQuiz);
